import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { SaleReportPayload } from 'app/types/reports/sale'

export const createSaleReport = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.sale.ALL}`,
    async ({ request }) => {
        const payload = await request.json()

        const payloadParsed = SaleReportPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
